(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sort"]) return;
  try {
    
function normalizeRosyLanaSort() {
  if (!document.querySelector('[data-rl-sort-fallback]')) return;
  const target = new URL(window.location.href);
  target.searchParams.set('sort_by', 'best-selling');
  target.searchParams.delete('page');
  window.location.replace(target.href);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', normalizeRosyLanaSort, {once:true});
else normalizeRosyLanaSort();
document.addEventListener('change', event => {
  const control = event.target;
  if (control.matches('[data-rl-collection-sort]')) {
    const target = new URL(window.location.href);
    target.searchParams.set('sort_by', control.value);
    target.searchParams.delete('page');
    window.location.assign(target.href);
  } else if (control.matches('[data-rl-collection-nav]')) {
    const target = new URL(control.value, window.location.origin);
    const sort = document.querySelector('[data-rl-collection-sort]');
    if (sort) target.searchParams.set('sort_by', sort.value);
    window.location.assign(target.href);
  }
});

  } catch(e) { console.error(e); }
})();
})();
